import React from 'react'
import { DropdownItem } from '@mc/design-system'
import Link, { type CustomLinkProps } from './Link'

const MenuLink = ({
  children,
  as,
  href,
  onClick = () => {},
  ...rest
}: CustomLinkProps &
  Pick<React.HTMLAttributes<HTMLButtonElement>, 'onClick'>) => (
  <DropdownItem closeOnClick onClick={onClick}>
    <Link className='mc-p-4 d-block' href={href} as={as} {...rest}>
      {children}
    </Link>
  </DropdownItem>
)

export default MenuLink
